/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MoveFunctionVisibility {
    PRIVATE = 'private',
    PUBLIC = 'public',
    FRIEND = 'friend',
}
